var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center mb-3 pt-4" },
          [
            _c("b-spinner", {
              staticStyle: { width: "5rem", height: "5rem" },
              attrs: { variant: "warning", label: "Spinning" }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass: "ml-3 mr-3",
                attrs: { rounded: "lg", id: "overlay" }
              },
              [
                _c("div", { staticClass: "row no-gutters mb-2 mt-4" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "h1",
                      {
                        staticClass: "mb-0 pb-0",
                        attrs: { "data-test-hook": "pageTitle" }
                      },
                      [
                        _c("i", {
                          staticClass: "far fa-credit-card pr-1",
                          attrs: { "data-test-hook": "titleIcon" }
                        }),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test-hook": "payment-information-title"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("xPaymentInformation")))]
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "card", attrs: { "header-bg-variant": "white" } },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "row mb-2 ml-0" },
                    [
                      _c("i", {
                        staticClass: "far fa-credit-card colorOrange"
                      }),
                      _c(
                        "strong",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            "data-test-hook":
                              "account-holder-payment-information-account-settings"
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xPaymentInformation")) + " "
                          )
                        ]
                      ),
                      _c(
                        "popper",
                        {
                          staticClass: "ml-4",
                          attrs: {
                            trigger: "hover",
                            options: { placement: "right" }
                          }
                        },
                        [
                          _c("div", { staticClass: "popper" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xPrimaryPaymentInformationMessage")
                                ) +
                                " "
                            )
                          ]),
                          _c("i", {
                            staticClass: "far fa-question-circle",
                            attrs: { slot: "reference" },
                            slot: "reference"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.activeSubscriptionPlatform === _vm.appleStore
                    ? _c("div", [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "p",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "account-holder-payment-information-apple-subscription-header"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("xPlanManagedByApple")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.subscriptionIsDunning
                              ? _c(
                                  "div",
                                  { staticClass: "card mt-3 bg-statusWarning" },
                                  [
                                    _c("div", { staticClass: "card-body" }, [
                                      _c("div", { staticClass: "row mb-2" }, [
                                        _c("div", { staticClass: "col" }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "mb-0 pb-0",
                                              attrs: {
                                                "data-test-hook":
                                                  "apple-payment-account-needs-attention"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "far fa-triangle-exclamation pr-1",
                                                attrs: {
                                                  "data-test-hook":
                                                    "apple-payment-account-needs-attention-icon"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "1rem",
                                                    "font-weight": "bold"
                                                  },
                                                  attrs: {
                                                    "data-test-hook":
                                                      "apple-payment-account-needs-attention-text"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "xYourAccountNeedsAttentionHeader"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "row mb-2 ml-2" },
                                        [
                                          _c("div", { staticClass: "col" }, [
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  "data-test-hook":
                                                    "apple-payment-method-issue-header-text"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "xPaymentMethodIssue"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "row mb-1 ml-2" },
                                        [
                                          _c("div", { staticClass: "col" }, [
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  "data-test-hook":
                                                    "apple-payment-method-issue-body-text"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "xApplePaymentMethodIssueBodyText"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass: "mt-4",
                                    attrs: {
                                      "data-test-hook":
                                        "account-holder-payment-information-apple-subscription-body"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("xUpdatePaymentMethodApple")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ])
                        ])
                      ])
                    : _vm.activeSubscriptionPlatform === _vm.googleStore
                    ? _c("div", [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "p",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "account-holder-payment-information-google-subscription-header"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("xPlanManagedByGoogle")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.subscriptionIsDunning
                              ? _c(
                                  "div",
                                  { staticClass: "card mt-3 bg-statusWarning" },
                                  [
                                    _c("div", { staticClass: "card-body" }, [
                                      _c("div", { staticClass: "row mb-2" }, [
                                        _c("div", { staticClass: "col" }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "mb-0 pb-0",
                                              attrs: {
                                                "data-test-hook":
                                                  "google-payment-account-needs-attention"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "far fa-triangle-exclamation pr-1",
                                                attrs: {
                                                  "data-test-hook":
                                                    "google-payment-account-needs-attention-icon"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "1rem",
                                                    "font-weight": "bold"
                                                  },
                                                  attrs: {
                                                    "data-test-hook":
                                                      "google-payment-account-needs-attention-text"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "xYourAccountNeedsAttentionHeader"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "row mb-2 ml-2" },
                                        [
                                          _c("div", { staticClass: "col" }, [
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  "data-test-hook":
                                                    "google-payment-method-issue-header-text"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "xPaymentMethodIssue"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "row mb-1 ml-2" },
                                        [
                                          _c("div", { staticClass: "col" }, [
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  "data-test-hook":
                                                    "google-payment-method-issue-body-text"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "xGooglePaymentMethodIssueBodyText"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass: "mt-4",
                                    attrs: {
                                      "data-test-hook":
                                        "account-holder-payment-information-google-subscription-body"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("xUpdatePaymentMethodGoogle")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.paymentInfo
                    ? _c("div", [
                        _vm.isMobileSubscription
                          ? _c("div", [
                              _c("hr", { staticClass: "mb-4 mt-4" }),
                              _c("div", { staticClass: "row mb-2 ml-0" }, [
                                _c(
                                  "strong",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "account-holder-unused-payment-information"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("xUnusedPaymentInformation")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-auto" }, [
                                  _c(
                                    "p",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "account-holder-unused-payment-information-body"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "xUnusedPaymentInformationBodyText"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "p",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "account-holder-payment-information-card-account-settings"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.paymentInfo.cardType.toUpperCase() +
                                        " - " +
                                        _vm.paymentInfo.cardSuffix
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "p",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "account-holder-payment-information-expiration-account-settings"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("xExpires") +
                                        " " +
                                        _vm.displayMonth(
                                          _vm.paymentInfo.expirationMonth
                                        ) +
                                        "/" +
                                        _vm.paymentInfo.expirationYear
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ]),
                        !_vm.isMobileSubscription && _vm.subscriptionIsDunning
                          ? _c(
                              "div",
                              { staticClass: "card mt-3 bg-statusWarning" },
                              [
                                _c("div", { staticClass: "card-body" }, [
                                  _c("div", { staticClass: "row mb-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "mb-0 pb-0",
                                          attrs: {
                                            "data-test-hook":
                                              "web-payment-account-needs-attention"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "far fa-triangle-exclamation pr-1",
                                            attrs: {
                                              "data-test-hook":
                                                "web-payment-account-needs-attention-icon"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "1rem",
                                                "font-weight": "bold"
                                              },
                                              attrs: {
                                                "data-test-hook":
                                                  "web-payment-account-needs-attention-text"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "xYourAccountNeedsAttentionHeader"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row mb-2 ml-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "web-payment-method-issue-header-text"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "xPaymentMethodIssuePleaseUpdate"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row ml-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-warning btn-update",
                                          attrs: {
                                            type: "button",
                                            "data-test-hook":
                                              "web-payment-method-issue-button",
                                            disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                                              _vm.currentAppConfig
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openModal(
                                                "update-payment-method"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "xUpdatePaymentInformation"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          : _vm.shouldShowUpdatePayment
                          ? _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-warning mt-3",
                                    attrs: {
                                      type: "button",
                                      title: _vm.$t(
                                        "xUpdatePaymentInformation"
                                      ),
                                      "data-test-hook":
                                        "update-payment-information-button-account-settings",
                                      disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                                        _vm.currentAppConfig
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal(
                                          "update-payment-method"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("xUpdatePaymentInformation")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm.shouldShowRemovePayment
                          ? _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-danger rounded-pill mt-3",
                                    attrs: {
                                      type: "button",
                                      title: _vm.$t(
                                        "xRemovePaymentInformation"
                                      ),
                                      "data-test-hook":
                                        "remove-payment-information-button-account-settings",
                                      disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                                        _vm.currentAppConfig
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removePaymentInformation()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-trash-alt colorOrange"
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("xRemovePaymentInformation")
                                        ) +
                                        " "
                                    ),
                                    _vm.removing
                                      ? _c("span", {
                                          staticClass: "spinner-border ml-2"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  !_vm.paymentInfo && !_vm.isMobileSubscription
                    ? _c("div", [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xNoSavedPaymentInformation")) +
                              " "
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _c(
              "Modal",
              {
                attrs: { modalId: "update-payment-method", size: "modal-lg" },
                on: {
                  hidden: function($event) {
                    return _vm.closePaymentModal()
                  }
                }
              },
              [
                _c(
                  "ModalHeader",
                  {
                    attrs: {
                      title: _vm.$t("xUpdatePaymentMethod"),
                      icon: "fal fa-credit-card colorOrange mr-1"
                    }
                  },
                  [
                    _c("div", { staticClass: "cols-auto" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-icon-button btn-icon-button--gray",
                          attrs: {
                            type: "button",
                            "data-test-hook": "CloseModalBtn"
                          },
                          on: {
                            click: function($event) {
                              _vm.closePaymentModal(),
                                (_vm.useExistingBillingInformation = true)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ])
                  ]
                ),
                _c("ModalBody", [
                  _vm.showValidationBanner
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: {
                            role: "alert",
                            "data-test-hook": "ValidationAlert"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("xExperiencedTheseErrors")))
                          ]),
                          _vm._l(_vm.errorMessages, function(message, index) {
                            return _c("ul", { key: index }, [
                              _c(
                                "li",
                                {
                                  attrs: {
                                    id: index,
                                    "data-test-hook": "ValidationMsg"
                                  }
                                },
                                [_vm._v(" " + _vm._s(message) + " ")]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.addressSearchError
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" }
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v(_vm._s(_vm.$t("xSomethingWentWrong")))
                          ]),
                          _c("p", { staticClass: "alert-body" }, [
                            _vm._v(_vm._s(_vm.$t("xWaitAndTryAgainErrorText")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  !_vm.isShowingValidationView
                    ? _c("div", [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("h3", [
                              _c(
                                "strong",
                                { attrs: { "data-test-hook": "CcInfoHeader" } },
                                [_vm._v(_vm._s(_vm.$t("xCreditCardInfo")))]
                              ),
                              _c("span", { staticClass: "body-text-color" }, [
                                _vm._v("*")
                              ])
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "row mb-3" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "i",
                              {
                                staticClass: "asterisk-text",
                                attrs: {
                                  "data-test-hook": "UpdatePaymentWarningMsg"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("xUpdatingPaymentWarning")) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                attrs: { id: "credit-card-number" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.$v.creditCardNumber.$model,
                                      expression: "$v.creditCardNumber.$model"
                                    },
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: "################",
                                      expression: "'################'"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.status(_vm.$v.creditCardNumber),
                                  attrs: {
                                    id: "creditCardNumber",
                                    maxlength: "16",
                                    type: "text",
                                    placeholder: _vm.$t("xCreditCardNumber"),
                                    "aria-describedby": "card-number-invalid",
                                    "data-test-hook": "CcNumber"
                                  },
                                  domProps: {
                                    value: _vm.$v.creditCardNumber.$model
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.$v.creditCardNumber,
                                        "$model",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "invalid-feedback",
                                    attrs: {
                                      id: "card-number-invalid",
                                      "data-test-hook": "invalidCcNo"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xCCFieldValidation")) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                attrs: { id: "expiry-date-month" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.$v.expirationMonth.$model,
                                      expression: "$v.expirationMonth.$model"
                                    },
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: "##",
                                      expression: "'##'"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.status(_vm.$v.expirationMonth),
                                  attrs: {
                                    id: "xNm",
                                    maxlength: "2",
                                    type: "text",
                                    placeholder: _vm.$t("xMm"),
                                    "aria-describedby": "expiry-month-invalid",
                                    "data-test-hook": "CcExpireMonth"
                                  },
                                  domProps: {
                                    value: _vm.$v.expirationMonth.$model
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.$v.expirationMonth,
                                        "$model",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "invalid-feedback",
                                    attrs: {
                                      id: "expiry-month-invalid",
                                      "data-test-hook": "invalidCcMth"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("xExpirationMonthValidation")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "col-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                attrs: { id: "expiry-date-year" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.$v.expirationYear.$model,
                                      expression: "$v.expirationYear.$model"
                                    },
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: "##",
                                      expression: "'##'"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.status(_vm.$v.expirationYear),
                                  attrs: {
                                    type: "text",
                                    placeholder: _vm.$t("xYy"),
                                    maxlength: "2",
                                    "aria-describedby": "expiry-year-invalid",
                                    "data-test-hook": "CcExpireYear"
                                  },
                                  domProps: {
                                    value: _vm.$v.expirationYear.$model
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.$v.expirationYear,
                                        "$model",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "invalid-feedback",
                                    attrs: {
                                      id: "expiry-year-invalid",
                                      "data-test-hook": "invalidCcYear"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("xExpirationYearValidation")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "col-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-group",
                                attrs: { id: "cvv" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.$v.cvv.$model,
                                      expression: "$v.cvv.$model"
                                    },
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: "####",
                                      expression: "'####'"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.status(_vm.$v.cvv),
                                  attrs: {
                                    type: "text",
                                    maxlength: "4",
                                    placeholder: _vm.$t("xCvv"),
                                    "aria-describedby": "cvv-invalid",
                                    "data-test-hook": "CcCvv"
                                  },
                                  domProps: { value: _vm.$v.cvv.$model },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.$v.cvv,
                                        "$model",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticClass: "input-group-append" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-text" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            height: 20,
                                            src: require("@/assets/images/3-digit-code.svg"),
                                            "data-test-hook": "ccCvvImage"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "invalid-feedback",
                                    attrs: {
                                      id: "cvv-invalid",
                                      "data-test-hook": "invalidCcCvv"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xCVVValidation")) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.accountData
                    ? _c("div", [
                        !_vm.isShowingValidationView
                          ? _c("div", [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c("h3", [
                                    _c(
                                      "strong",
                                      {
                                        attrs: {
                                          "data-test-hook":
                                            "BillingInformationTitle"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "xBillingInformationLowercase"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.useExistingBillingInformation,
                                            expression:
                                              "useExistingBillingInformation"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "useExistingBillingInformation",
                                          type: "checkbox",
                                          disabled: _vm.savingAccountHolder,
                                          "data-test-hook":
                                            "UseCurrentBillingAddressChkBox"
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.useExistingBillingInformation
                                          )
                                            ? _vm._i(
                                                _vm.useExistingBillingInformation,
                                                null
                                              ) > -1
                                            : _vm.useExistingBillingInformation
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a =
                                                _vm.useExistingBillingInformation,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.useExistingBillingInformation = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.useExistingBillingInformation = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.useExistingBillingInformation = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for:
                                              "useExistingBillingInformation",
                                            "data-test-hook":
                                              "useCurrBillingInfoText"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("xUseCurrentBillingInfo")
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm.useExistingBillingInformation
                                ? _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12",
                                        attrs: {
                                          "data-test-hook":
                                            "ExistingBillingName"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.accountProfile.firstName
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.accountProfile.lastName
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12",
                                        attrs: {
                                          "data-test-hook":
                                            "ExistingBillingAddress"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.DisplayAddress(
                                                _vm.accountProfile.address
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        !_vm.useExistingBillingInformation
                          ? _c("div", [
                              !_vm.isShowingValidationView
                                ? _c("div", [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-12" }, [
                                        _c(
                                          "fieldset",
                                          {
                                            staticClass: "form-group",
                                            attrs: { id: "firstName-group" }
                                          },
                                          [
                                            _c("div", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.accountData.firstName,
                                                    expression:
                                                      "accountData.firstName"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  id: "firstName",
                                                  "data-test-hook": "firstName"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.accountData.firstName
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.accountData,
                                                      "firstName",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        )
                                      ])
                                    ]),
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-12" }, [
                                        _c(
                                          "fieldset",
                                          {
                                            staticClass: "form-group",
                                            attrs: { id: "lastName-group" }
                                          },
                                          [
                                            _c("div", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.accountData.lastName,
                                                    expression:
                                                      "accountData.lastName"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  id: "lastName",
                                                  type: "text",
                                                  "data-test-hook": "lastName"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.accountData.lastName
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.accountData,
                                                      "lastName",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("AddressSearchModals", {
                                      ref: "updateCardAddressSearchModalsRef",
                                      attrs: {
                                        addressSearchModalId:
                                          "update-card-address-search-form",
                                        addressValidationModalId:
                                          "update-card-address-validation-form",
                                        inline: true,
                                        showContinueButton: false,
                                        showValidationButtons: false,
                                        showAddressCheckmarkHeader: false,
                                        isBillingAddress: true
                                      },
                                      on: {
                                        onSubmit: _vm.saveAccountHolder,
                                        addressSearchModalViewChanged:
                                          _vm.handleValidationStateChange,
                                        setIsNextDisabled:
                                          _vm.handleSetIsNextDisabled,
                                        addressSearchError:
                                          _vm.handleAddressSearchError
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _c("ModalFooter", [
                  _vm.useExistingBillingInformation
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-block btn-primary",
                          attrs: {
                            type: "button",
                            disabled: !_vm.canPay(),
                            "data-test-hook": "SaveChangesBtn"
                          },
                          on: {
                            click: function($event) {
                              return _vm.payForProduct()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("xSave")) + " "),
                          _vm.paying
                            ? _c("span", { staticClass: "spinner-border ml-2" })
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  !_vm.useExistingBillingInformation &&
                  !_vm.isShowingValidationView
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-warning btn-block",
                          attrs: {
                            variant: "outline-warning",
                            "data-test-hook": "SaveChangesBtn"
                          },
                          on: {
                            click: function($event) {
                              return _vm.addBillingAddress()
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xConfirmBillingInfo")) + " "
                          ),
                          _vm.savingAddress
                            ? _c("span", [
                                _c("div", {
                                  staticClass: "spinner-border ml-2"
                                })
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  !_vm.useExistingBillingInformation &&
                  _vm.isShowingValidationView &&
                  !_vm.showContactSupportButton
                    ? _c("div", { staticClass: "row w-100 m-0" }, [
                        _c("div", { staticClass: "col pr-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-warning btn-block",
                              attrs: {
                                variant: "outline-warning",
                                "data-test-hook": "edit-address-button"
                              },
                              on: { click: _vm.editAddress }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("xAddressSearchEditAddress")) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "col pl-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-warning btn-block",
                              attrs: {
                                variant: "warning",
                                disabled: _vm.confirmAddressDisabled,
                                "data-test-hook": "confirm-address-button"
                              },
                              on: { click: _vm.confirmAddress }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("xAddressSearchConfirmAddress")
                                  ) +
                                  " "
                              ),
                              _vm.savingAccountHolder
                                ? _c("span", [
                                    _c("div", {
                                      staticClass: "spinner-border ml-2"
                                    })
                                  ])
                                : _c("span", [
                                    _c("i", {
                                      staticClass: "far fa-arrow-right"
                                    })
                                  ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  !_vm.useExistingBillingInformation &&
                  _vm.isShowingValidationView &&
                  _vm.showContactSupportButton
                    ? _c("div", { staticClass: "row w-100 m-0" }, [
                        _c("div", { staticClass: "col pr-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-warning btn-block",
                              attrs: {
                                variant: "outline-warning",
                                "data-test-hook": "edit-address-button"
                              },
                              on: { click: _vm.editAddress }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("xAddressSearchEditAddress")) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "col pl-1" }, [
                          !_vm.useExistingBillingInformation &&
                          _vm.isShowingValidationView &&
                          _vm.showContactSupportButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning btn-block",
                                  attrs: {
                                    variant: "warning",
                                    "data-test-hook": "contact-support-button"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push({
                                        path: `/support`
                                      })
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xContactSupport")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }